/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';

import { FlexCol, FlexRow } from 'sarsaparilla';

import { ScanPayPromo } from 'site-kit';

export default function Promo() {
    return (
        <div className="ap-promo">
            <FlexRow>
                <FlexCol>
                    <div className="ap-promo-container">
                        <ScanPayPromo
                            inventoryType="location"
                            href="https://www.recreation.gov/mobile-app"
                        />
                    </div>
                </FlexCol>
            </FlexRow>
        </div>
    );
}

Promo.propTypes = {};
